"use strict";

var _regeneratorRuntime = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contracts_1 = require("@archanova/contracts");

var ethjs_abi_1 = require("ethjs-abi");

var Contract = /*#__PURE__*/function () {
  function Contract(eth) {
    _classCallCheck(this, Contract);

    this.eth = eth;
    this.account = this.createInstance(contracts_1.getContractAbi(contracts_1.ContractNames.Account));
    this.accountFriendRecovery = this.createInstance(contracts_1.getContractAbi(contracts_1.ContractNames.AccountFriendRecovery), eth.getContractAddress(contracts_1.ContractNames.AccountFriendRecovery));
    this.accountProvider = this.createInstance(contracts_1.getContractAbi(contracts_1.ContractNames.AccountProvider), eth.getContractAddress(contracts_1.ContractNames.AccountProvider));
    this.accountProxy = this.createInstance(contracts_1.getContractAbi(contracts_1.ContractNames.AccountProxy), eth.getContractAddress(contracts_1.ContractNames.AccountProxy));
    this.ensRegistry = this.createInstance(contracts_1.getContractAbi(contracts_1.ContractNames.ENSRegistry), eth.getContractAddress(contracts_1.ContractNames.ENSRegistry));
    this.ensResolver = this.createInstance(contracts_1.getContractAbi(contracts_1.ContractNames.ENSResolver), null);
    this.erc20Token = this.createInstance(contracts_1.getContractAbi(contracts_1.ContractNames.ERC20Token), null);
    this.virtualPaymentManager = this.createInstance(contracts_1.getContractAbi(contracts_1.ContractNames.VirtualPaymentManager), eth.getContractAddress(contracts_1.ContractNames.VirtualPaymentManager));
  }

  _createClass(Contract, [{
    key: "createInstance",
    value: function createInstance(abi) {
      var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return new Contract.ContractInstance(address, abi, this.eth);
    }
  }]);

  return Contract;
}();

exports.Contract = Contract;

(function (Contract) {
  var ContractInstance = /*#__PURE__*/function () {
    function ContractInstance(address, abi, eth) {
      _classCallCheck(this, ContractInstance);

      this.address = address;
      this.abi = abi;
      this.eth = eth; //
    }

    _createClass(ContractInstance, [{
      key: "at",
      value: function at(address) {
        return new ContractInstance(address, this.abi, this.eth);
      }
    }, {
      key: "getMethodSignature",
      value: function getMethodSignature(method) {
        return ethjs_abi_1.encodeSignature(this.getAbiItem(method));
      }
    }, {
      key: "callMethod",
      value: function callMethod(method) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var input, output;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  input = this.encodeMethodInput.apply(this, [method].concat(args));
                  _context.next = 3;
                  return this.eth.call({
                    data: input,
                    to: this.address
                  }, 'latest');

                case 3:
                  output = _context.sent;
                  return _context.abrupt("return", this.decodeMethodOutput(method, output));

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
      }
    }, {
      key: "encodeMethodInput",
      value: function encodeMethodInput(method) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        return ethjs_abi_1.encodeMethod(this.getAbiItem(method), args);
      }
    }, {
      key: "decodeMethodOutput",
      value: function decodeMethodOutput(method, output) {
        return ethjs_abi_1.decodeMethod(this.getAbiItem(method), output);
      }
    }, {
      key: "getAbiItem",
      value: function getAbiItem(method) {
        return this.abi.find(function (_ref) {
          var name = _ref.name;
          return name === method;
        });
      }
    }]);

    return ContractInstance;
  }();

  Contract.ContractInstance = ContractInstance;
})(Contract = exports.Contract || (exports.Contract = {}));